<template>
<div class="page">
  <component :is="{template: '<div>'+html+'</div>', methods: vue_js.methods, beforeCreate: vue_js.beforeCreate, created: vue_js.created, mounted: vue_js.mounted, watch: vue_js.watch, computed: vue_js.computed, components: $options.components, data: function() { return Object.assign({data:vue_data, mod:mod, view:view, func:func, subpage:subpage, args:args }, vue_js.data) } }" />
  </div>
</div>
</template>

<script>
import { mapGetters } from 'vuex'
import { mapState } from 'vuex'
import Editable from "../components/Editable.vue"
import User from "../components/User.vue"
import Entry from "../components/Entry.vue"
import AccountComments from "../components/AccountComments.vue"
import Marketingphoto from "../components/Marketingphoto.vue"
import Accounts from "../components/Accounts.vue"
import PrintCheck from "../components/PrintCheck.vue"
import Popup from "../components/Popup.vue"
import DatePicker from "../components/DatePicker.vue"
import DateRangePicker from "../components/DateRangePicker.vue"
import { GChart } from 'vue-google-charts'
import { Plotly } from 'vue-plotly'
import {gmapApi} from 'vue2-google-maps'
import GmapCustomMarker from 'vue2-gmap-custom-marker';
var moment = require('moment');
var pako = require('pako');

function check_vue_js(obj) {
    if(obj.methods === undefined) {
        obj.methods = {}
    }
    if(obj.mounted === undefined) {
        obj.mounted = function() { }
    }
    if(obj.computed === undefined) {
	obj.comptued = {
	    google: gmapApi,
	}
    }
    if(obj.watch === undefined) {
	obj.watch = {}
    }
    if(obj.created === undefined) {
	obj.created = function() {}
    }
    if(obj.beforeCreate === undefined) {
	obj.beforeCreate = function() {}
    }
    if(obj.data === undefined) {
	obj.data = {}
    }
    return obj
}

export default {
    name: 'Page',
    props: {
	subpage: Boolean,
	subpagemod: String,
	subpageview: String,
	subpagefunc: String,
	args: Object,
    },
    data: function() {
        return {
            mod  : "",
            view : "",
            func : "",
            html : "?",
            query: {},
            vue_data : {},
            vue_js   : check_vue_js({}),
            css  : null,
        }
    },
    watch: {
        entity(to, from) {
            this.fetch()
        },
        host(to, from) {
            this.fetch()
        },
        race(to, from) {
            this.fetch()
        },
        $route(to, from) {
            this.update()
        }
    },
    computed: {
        ...mapState(['context']),
        ...mapGetters(['entity','host','race']),
    },
    mounted: function() {
        this.update()
    },
    methods: {
        update: function() {
	    let mod, view, func;
	    if(this.subpage) {
		mod  = this.subpagemod
		view = this.subpageview
		func = this.subpagefunc
	    } else {
		mod = this.$route.params.mod
		view= this.$route.params.view
		func= this.$route.params.func
	    }
	    
            let changed = (this.mod !== mod || this.view !== view || this.func !== func);
            for(var k in this.$route.query) {
                if(this.query[k] !== this.$route.query[k]) {
                    changed=true
                    break
                }
            }
            for(var k in this.query) {
                if(this.query[k] !== this.$route.query[k]) {
                    changed=true
                    break
                }
            }
            if(changed) {
                this.mod  = mod
                this.view = view
                this.func = func
                this.fetch()
            }
        },
        fetch: function() {
            this.html = "Loading"
            this.vue_data = {}
            this.vue_js = check_vue_js({})
            this.set_css("")
            var self = this
	    let args = {}
	    if(this.args) {
		Object.assign(args, this.args)
	    }
	    if(!this.subpage) {
		Object.assign(args, self.$route.query)
	    }
            self.rpc(this.mod, this.view, this.func, args, "Loading...")
                .then(function(result) {
                    self.html = result.html
                    self.vue_data = result.data
                    if(result.vue_js !== undefined) {
                        self.vue_js = check_vue_js(eval("(" + result.vue_js + ")"))
                    }
                    self.set_css(result.css)
                })
                .catch(function(error) {
                    console.log(error)
                    self.html = error.result
                    self.$store.commit('showError',error)
                })
        },
        set_css: function(css) {
            this.css = document.getElementById("_page_style_"+this._uid)
            if(this.css === null) {
                this.css = document.createElement('style')
                this.css.setAttribute("id", "_page_style_" + this.uid)
                document.head.appendChild(this.css)
            }
            this.css.innerHTML = css === undefined || css === null ? "" : css
        }
    },
    destroyed: function() {
	if(this.css !== null) {
	    this.css.remove()
	    this.css = null
	}
    },
    components: {
        Editable, User, Entry, GChart, Plotly, Accounts, Marketingphoto, PrintCheck, Popup, 'gmap-custom-marker': GmapCustomMarker, DatePicker, DateRangePicker, AccountComments
    }
}
</script>

<style scoped>
</style>
